import { FETCH_SHIPMENT_DATA_STARTED, FETCH_SHIPMENT_DATA_SUCCEEDED } from '#action/types';
import { fetchShipment } from './dashboard';
import { fetchDelivery } from './delivery';
import { fetchCargo, fetchShipmentCargo } from './cargo';
import { fetchShipmentFiles } from './files';

export const fetchShipmentDeliveryCargoFiles = (id, withCustomFields) => async dispatch => {
  dispatch({ type: FETCH_SHIPMENT_DATA_STARTED });
  await Promise.all([
    dispatch(fetchShipment(id, withCustomFields)),
    dispatch(fetchDelivery(id)),
    dispatch(fetchCargo(id)),
    dispatch(fetchShipmentFiles(id))
  ]);
  dispatch({ type: FETCH_SHIPMENT_DATA_SUCCEEDED });
};

export const fetchShipmentDeliveryCargo = (id, withCustomFields) => async dispatch => {
  dispatch({ type: FETCH_SHIPMENT_DATA_STARTED });
  await Promise.all([
    dispatch(fetchShipment(id, withCustomFields)),
    dispatch(fetchDelivery(id)),
    dispatch(fetchCargo(id))
  ]);
  dispatch({ type: FETCH_SHIPMENT_DATA_SUCCEEDED });
};

export const fetchCargoFiles = id => async dispatch => {
  dispatch({ type: FETCH_SHIPMENT_DATA_STARTED });
  await Promise.all([
    dispatch(fetchShipmentCargo(id)),
    dispatch(fetchShipmentFiles(id))
  ]);
  dispatch({ type: FETCH_SHIPMENT_DATA_SUCCEEDED });
};
